// Shared API URL utility - auto-detects correct URL for production vs preview
// SELF-HEALING: always uses the EXACT origin the page was loaded from.
// This prevents www <-> non-www 308 redirects from breaking POST requests
// (iOS Safari and others drop POST bodies across cross-host redirects).

export const getApiUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    // Production: always use whatever hostname the user is currently on.
    // If they're on craftersmarket.com.au — use that. If they're on www.* — use that.
    // No redirect, no dropped POST bodies.
    if (hostname === 'craftersmarket.com.au' || hostname === 'www.craftersmarket.com.au') {
      return `${window.location.protocol}//${hostname}`;
    }
  }
  // Otherwise use the env variable (for preview/development)
  return process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : '');
};

export const API_URL = getApiUrl();
